import axios from "axios";
import { IExaminationOrganization } from "../models/examinationOrganization";

export const getExaminationOrganizations = async () => {
    const res = await axios.get("/api/examinationOrganizations");
    return res.data as IExaminationOrganization;
};

export const editExaminationOrhanizationsAsync = async (data: IExaminationOrganization) => {
    await axios.patch("/api/examinationOrganizations", data);
};

export const fetchExaminationOrganizationByGuid = async(guid: string) => {
    const res = await axios.get(`/api/examinationOrganizations/${guid}`);
    return  res.data as IExaminationOrganization;
};

export const deleteExaminationOrganizationByGuid = async(guid: string) => {
    await axios.delete(`/api/examinationOrganizations/${guid}`);
};

export const orderExamninationOrganization = async(guid: string, orderDirection: boolean) => {
    await axios.post(`/api/examinationOrganizations/${guid}/order/${orderDirection}`);
};

export const createExaminationOrganization = async (data: IExaminationOrganization) => {
    await axios.post("/api/examinationOrganizations", data);
};
